/**
 * 外接遊戲設定
 * @typedef {Object} ExternalGameSetting
 * @property {string} GameType - 遊戲類型
 * @property {string} State - 狀態 (ExternalGameState 值)
 * @property {boolean} UseIFrameForPC - PC 內嵌設定
 * @property {boolean} UseIFrameForAPP - APP 內嵌設定
 * @property {string} MaintainStartTimeStr - 維護開始時間字串
 * @property {string} MaintainEndTimeStr - 維護結束時間字串
 * @property {string} FrontEndType - 前端類型 (FrontEndType 值)
 * @property {string} [Note] - 備註，最大長度 200 字符
 */

/**
 * 外接遊戲設定配置
 * @typedef {Object.<string, ExternalGameSetting>} ExternalGameSettingConfig
 */

export default {
    name: 'ExternalGameConfig',
    data() {
        return {
            isLoading: false
        };
    },
    methods: {
        /**
         * 獲取外接遊戲配置
         * @returns {Promise<ExternalGameSettingConfig|null>} 外接遊戲配置
         */
        async getExternalGameConfig() {
            this.isLoading = true;
            
            try {
                const response = await $.getJSON('/api/ExternalGame/GetExternalGameConfig');
                return response;
            } catch (error) {
                console.error('獲取外接遊戲配置失敗:', error);
                return null;
            } finally {
                this.isLoading = false;
            }
        }
    }
} 